import React, { useEffect, useRef, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import EditProfileForm from "./EditProfileForm";
import { updateUserProTeam, getUserByIdProTeam } from "../../../api/endpoints";
import { ReactComponent as LoadingIcon } from "../../../assets/svg/loading.svg";
import axiosInstant from "../../../api";
import {
  ProFormTabs,
  defaultTabsPercentage,
  getProfilePercentage,
} from "./tabs";
import { TabsPanel } from "./tabsPanel";
import ExpertFormHeader from "./ExpertFormHeader";
import { MainContainer } from "../../../components/ContentWrapper";
import { handleProfileImageUpdate } from "../../profile/helper";

export default function EditProfile() {
  const params = useParams();
  const prevValues = useRef("");
  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const [pro, setPro] = useState({ userid: 0 });
  const [selectedTab, updateTab] = useState(ProFormTabs.Basics);
  const [percentage, setPercentage] = useState(defaultTabsPercentage);

  useEffect(() => {
    const getUser = async (id) => {
      const response = await axiosInstant.get(getUserByIdProTeam(id));
      const { data } = response;
      setPro(data);
      return data;
    };
    const { id } = params;
    getUser(id || "");
  }, []);

  const handleSubmit = async (values, actions) => {
    try {
      const avatarUrl = await handleProfileImageUpdate(values, values, (errorMsg) => {
        toast.error(errorMsg);
        actions.setSubmitting(false);
      });
      
      if (avatarUrl === null && (values.avatarFile || (values.avatar && values.avatar.startsWith('data:image/')))) {
        return;
      }

      const response = await axiosInstant.patch(updateUserProTeam(values.userid), values);
      const { data } = response;

      actions.setSubmitting(false);
      toast.success("Updated user information successfully!", { duration: 3000 });
      setPro(data);
      return data;
    } catch (error) {
      const errorMessage = error?.response?.data;
      if (errorMessage === 'EmailAlreadyExists') {
        toast.error("Email already exists");
      } else {
        toast.error("Profile update failed");
      }
      actions.setSubmitting(false);
    }
  };

  const updatePercentage = (profile) => {
    const res = getProfilePercentage(profile);
    const newValues = JSON.stringify(res);
    if (prevValues.current !== newValues) {
      prevValues.current = newValues;
      setPercentage({ ...res });
    }
  };

  const tabProps = { selectedTab, updateTab };
  return (
    <MainContainer>
      <ExpertFormHeader pro={pro} />

      {/* main content */}
      <Box
        display="flex"
        gap={2}
        mt={5}
        flexDirection={isSmallScreen ? "column" : "row"}
      >
        <TabsPanel
          {...tabProps}
          inline={isSmallScreen}
          percentage={{ ...percentage }}
        />
        {!pro.userid && <LoadingIcon />}
        {pro.userid > 0 && (
          <EditProfileForm
            {...tabProps}
            pro={pro}
            onProUpdate={updatePercentage}
            handleSubmit={handleSubmit}
          />
        )}
      </Box>
    </MainContainer>
  );
}
